import advance from 'locales/dental/th/finance/advance.json'
import incomeExpenses from 'locales/dental/th/finance/income-expenses.json'
import overdue from 'locales/dental/th/finance/overdue.json'
import paymentQueue from 'locales/dental/th/finance/payment-queue.json'
import payment from 'locales/dental/th/finance/payment.json'
import salary from 'locales/dental/th/finance/salary.json'
import installment from 'locales/dental/th/finance/installment.json'

export const Payment = {
  ...advance,
  ...incomeExpenses,
  ...overdue,
  ...paymentQueue,
  ...payment,
  ...salary,
  ...installment
}
